import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  OrganizationNoteAuthorResponse,
  OrganizationNoteResponse,
} from '../../Interfaces/api/backoffice/organization-note.interface';

export class OrganizationNote {
  id = '';
  organization_id = '';
  body: string | null = null;
  pinned = false;
  created_at: string | null = null;
  updated_at: string | null = null;
  author: OrganizationNoteAuthorResponse | null = null;

  constructor(data: Partial<OrganizationNoteResponse> = {}) {
    Object.assign(this, data);
  }

  get authorName(): string {
    return this.author?.name || this.author?.email || VALUE_UNRESOLVED;
  }

  get isEdited(): boolean {
    return this.updated_at !== null && this.updated_at !== this.created_at;
  }

  isAuthoredBy(operatorId: string | null | undefined): boolean {
    return !!operatorId && this.author?.id === operatorId;
  }
}
